export enum OutsourcingBenefits {
	PAYROLL_HANDLING = 'PAYROLL_HANDLING',
	LEGAL_CONTRACTS_FOR_REMOTE_TALENTS = 'LEGAL_CONTRACTS_FOR_REMOTE_TALENTS',
	HEALTH_INSURANCE = 'HEALTH_INSURANCE',
	OFFICE_SPACE = 'OFFICE_SPACE',
	LAPTOPS_OR_DEVICES = 'LAPTOPS_OR_DEVICES',
	HR_SERVICES = 'HR_SERVICES'
}
